import cn from 'classnames';

import { useTranslationContext } from 'hooks';
import { TrackerServiceInstance } from 'services';

import HeaderClasses from '../Header.module.scss';

export default function DonationBlock(props: { donationURL?: string } = {}) {
  const { donationURL } = props;
  const { t, translateCustomText } = useTranslationContext();

  const handleDonateClick = (event: any) => {
    TrackerServiceInstance?.trackEvent('clickDonate', {
      event_category: 'Donate'
    });

    // window.open(client?.donationURL, '_blank', 'noreferrer');
  };


  return (
    <>
      {donationURL ? (
        <a id="donate_button" className={cn(HeaderClasses.navLink, 'donate')} href={donationURL} onClick={handleDonateClick} target="_blank" rel="noreferrer">
          {translateCustomText("headerDonateLinkText", t("Donate"))}
        </a>
      ) : null}
    </>
  );
}
